import React from 'react';
import {h, Component} from 'preact'

export default class StartBtn extends Component {
    render() {
        const {start_btn, sendMessage} = this.props;
        return (
            <div className="centered-content">
                <button
                    type="button"
                    className="start-btn"
                    onClick={() => sendMessage('start')}
                >
                    {start_btn}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/StartBtn.js